import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.erpWebhook.index'),
        name: 'erpWebhooks.index',
        component: () =>
            import(
                /* webpackChunkName: "erpWebhoks" */ '@/views/erp-webhooks/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.erpWebhook.breadcrumb.index'),
                    to: { name: 'erpWebhooks.index' },
                    disable: true,
                },
            ],
        },
    },
]
